import { render, staticRenderFns } from "./HaeufigeFragen.vue?vue&type=template&id=6fc5d1c2&scoped=true&"
import script from "./HaeufigeFragen.vue?vue&type=script&lang=js&"
export * from "./HaeufigeFragen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc5d1c2",
  null
  
)

export default component.exports